import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaChevronRight } from 'react-icons/fa';
import './Breadcrumb.scss';

interface BreadcrumbItem {
  label: string;
  path: string;
}

const Breadcrumb: React.FC = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);

  // Don't show breadcrumbs on home page
  if (location.pathname === '/' || location.pathname === '/home') {
    return null;
  }

  // Route labels mapping
  const routeLabels: { [key: string]: string } = {
    'who-we-are': 'Who We Are',
    'development-process': 'Development Process',
    'full-stack-expert': 'Full Stack Expert',
    'development-reviews': 'Reviews',
    'services': 'Services',
    'web-development': 'Web Development',
    'web-application-development': 'Web Application Development',
    'mobile-app-development': 'Mobile App Development',
    'ui-ux-design': 'UI/UX Design',
    'ecommerce-development': 'E-commerce Solutions',
    'digital-marketing': 'Digital Marketing',
    'cloud-solutions': 'Cloud Solutions',
    'devops': 'DevOps',
    'portfolio': 'Portfolio',
    'blogs': 'Blogs',
    'blog': 'Blog',
    'pricing': 'Pricing',
    'contact': 'Contact',
    'faq': 'FAQ',
    'disclaimer': 'Disclaimer',
    'terms': 'Terms & Conditions',
    'privacy': 'Privacy Policy'
  };

  // Build breadcrumb items
  const breadcrumbs: BreadcrumbItem[] = [];
  let currentPath = '';

  pathnames.forEach((segment, index) => {
    currentPath += `/${segment}`;
    
    // Get label from mapping or format segment
    let label = routeLabels[segment] || segment
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    // For blog detail pages, get the slug as title
    if (pathnames[index - 1] === 'blog' && !routeLabels[segment]) {
      label = segment
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    }

    breadcrumbs.push({
      label,
      path: currentPath
    });
  });

  return (
    <nav className="breadcrumb" aria-label="Breadcrumb">
      <div className="breadcrumb__container">
        <ol className="breadcrumb__list">
          {/* Home */}
          <li className="breadcrumb__item">
            <Link to="/" className="breadcrumb__link breadcrumb__link--home">
              <FaHome className="breadcrumb__home-icon" />
              <span>Home</span>
            </Link>
          </li>

          {/* Dynamic breadcrumbs */}
          {breadcrumbs.map((crumb, index) => {
            const isLast = index === breadcrumbs.length - 1;
            
            return (
              <li key={crumb.path} className="breadcrumb__item">
                <FaChevronRight className="breadcrumb__separator" />
                {isLast ? (
                  <span className="breadcrumb__current" aria-current="page">
                    {crumb.label}
                  </span>
                ) : (
                  <Link to={crumb.path} className="breadcrumb__link">
                    {crumb.label}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumb;
